import(/* webpackMode: "eager", webpackExports: ["ReadPageClient"] */ "/app/app/[locale]/read/read-page-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
